module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "mb-3"
  }, [_c('progress-bar', {
    staticClass: "my-0",
    attrs: {
      "show": _vm.busy
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.$t('your_bookings')))])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mb-2"
  }), _vm._v(" "), (_vm.bookings.length > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.bookings), function(booking, index) {
    return _c('div', {
      key: index,
      staticClass: "pb-2"
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md8": ""
      }
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(booking.trip_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(booking.date_from) + " - " + _vm._s(booking.date_to))]), _vm._v(" "), _c('div', [_vm._v("Booking no: " + _vm._s(booking.booking_id))])]), _vm._v(" "), (booking.client_id == _vm.user.client_id) ? _c('v-flex', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [(booking.status_id == 10) ? _c('v-chip', {
      attrs: {
        "color": "primary",
        "text-color": "white"
      }
    }, [_vm._v("Request")]) : _vm._e(), _vm._v(" "), (booking.status_id == 30) ? _c('v-chip', {
      attrs: {
        "color": "secondary",
        "text-color": "white"
      }
    }, [_vm._v("Offered")]) : _vm._e(), _vm._v(" "), (booking.status_id == 50) ? _c('v-chip', {
      attrs: {
        "color": "red",
        "text-color": "white"
      }
    }, [_vm._v("Not paid")]) : _vm._e(), _vm._v(" "), (booking.status_id == 70) ? _c('v-chip', {
      attrs: {
        "color": "orange",
        "text-color": "white"
      }
    }, [_vm._v("Deposit paid")]) : _vm._e(), _vm._v(" "), (booking.status_id == 80) ? _c('v-chip', {
      attrs: {
        "color": "green",
        "text-color": "white"
      }
    }, [_vm._v("Fully paid")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), (_vm.bookings.length == 0) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('i', [_vm._v("No bookings")])]) : _vm._e()], 2), _vm._v(" "), (_vm.invoices_all.length > 0) ? _c('v-card', {
    staticClass: "mb-3"
  }, [_c('v-card-title', {
    staticClass: "grey lighten-4",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v(_vm._s(_vm.$t('invoices')))])]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Invoice no.")]), _vm._v(" "), _c('td', [_vm._v("Booking no.")]), _vm._v(" "), _c('td', [_vm._v("Total amount")]), _vm._v(" "), _c('td', [_vm._v("Due payment")]), _vm._v(" "), _c('td', [_vm._v("Due date")]), _vm._v(" "), _c('td')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices_all), function(invoice, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      attrs: {
        "href": _vm.invoice_url + invoice.token,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(invoice.fortnox_invoice_no))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.booking_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.amount_total) + " " + _vm._s(invoice.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((invoice.amount_total - invoice.paid_amount).toFixed(2)) + " " + _vm._s(invoice.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.due_date))]), _vm._v(" "), _c('td', [(invoice.status < 100 && invoice.amount_total - invoice.paid_amount > 0) ? _c('router-link', {
      attrs: {
        "to": '/pay/' + invoice.token
      }
    }, [_c('v-btn', {
      staticClass: "ml-0",
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("Pay")])], 1) : _vm._e()], 1)])
  }), 0)])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46950f15","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bookings.vue
// module id = e14p
// module chunks = 1